import EnquiryForm from './EnquiryForm.jsx';
import Reveal from '../shared/Reveal.jsx';
import { admissionSteps } from '../constants/admissions.js';
import { school } from '../constants/school.js';

export default function Admissions() {
  return (
    <section id="admissions" className="relative bg-cream pb-25">
      <div className="mx-auto max-w-[1240px] px-5 sm:px-8">
        <Reveal className="rounded-[40px] border-[3px] border-forest bg-white px-6 py-10 shadow-[0_12px_0_rgb(20_83_45_/_0.13)] sm:px-11 sm:py-[46px]">
          <div className="flex flex-wrap items-end gap-[26px]">
            <div className="min-w-[280px] flex-1">
              <p className="font-hand text-2xl text-coral">Joining us</p>
              <h2 className="mt-1.5 font-display text-[clamp(28px,3.4vw,46px)] font-extrabold leading-[1.03] text-forest">
                Four steps, about three weeks
              </h2>
            </div>
            <p className="flex items-center gap-2.5 rounded-full bg-coral px-5 py-[11px] text-[15px] font-bold text-white">
              <span
                aria-hidden="true"
                className="size-[9px] flex-none rounded-full bg-sun animate-pulse-ring"
              />
              September intake closes 30 August
            </p>
          </div>

          <ol className="mt-[34px] grid gap-5 sm:grid-cols-2 xl:grid-cols-4">
            {admissionSteps.map((item, i) => (
              <Reveal
                as="li"
                key={item.step}
                index={i}
                className={`rounded-3xl p-[22px] ${
                  item.emphasis
                    ? 'border-[3px] border-forest bg-mint'
                    : 'border-2 border-dashed border-sage'
                }`}
              >
                <p className="font-display text-[15px] font-extrabold text-coral">
                  {item.step}
                </p>
                <h3 className="mt-0.5 font-display text-[23px] font-extrabold text-forest">
                  {item.title}
                </h3>
                <p className="mt-2 text-[15px] leading-[1.5] text-ink-soft">
                  {item.body}
                </p>
              </Reveal>
            ))}
          </ol>

          <p className="mt-8 text-[15px] text-ink-soft">
            Fill this in and we take it from there — or call{' '}
            <a
              href={`tel:${school.phone.replace(/\s/g, '')}`}
              className="font-bold text-forest"
            >
              {school.phone}
            </a>{' '}
            — a person answers, 8am–5pm.
          </p>

          <div className="mt-5">
            <EnquiryForm />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
